import { Action, Dispatch } from 'redux'
import { FirebaseDocRefType } from 'firebase/index'
import { StoreDeliverySettingType } from 'types/storeDeliverySetting'
import { fetchStoreDeliverySettingsAction } from 'reducks/storeDeliverySetting/actions'

const fetchStoreDeliverySettings = (storeRef: FirebaseDocRefType) => {
  return async (dispatch: Dispatch<Action>) => {
    return storeRef
      .collection('store_delivery_settings')
      .get()
      .then((snapshots) => {
        const storeDeliverySettings = snapshots.docs.map((snapshot) => {
          const data = snapshot.data() as StoreDeliverySettingType
          data.ref = snapshot.ref
          return data
        })
        dispatch(fetchStoreDeliverySettingsAction(storeDeliverySettings))
      })
      .catch((error: unknown) => {
        console.error(error)
      })
  }
}

export default fetchStoreDeliverySettings
